import { ReactNode } from "react";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import WbSunnyIcon from '@mui/icons-material/WbSunny';

import "./style.less";
import { myUseState } from "~/hooks/myUseState";

export interface IThemeSwitcherChangeData {
	state: boolean
}

interface IState {
	state: boolean;
}

interface IThemeSwitcher {
	state: boolean;
	onChange: (data: IThemeSwitcherChangeData) => void;
	// vice prepinacu na strance (rezim, jazyk) - kazdy musi mit vlastni id
	id?: string;
	// ikony vlevo a vpravo, vychozi slunce a mesic
	leftIcon?: ReactNode;
	rightIcon?: ReactNode;
}

export default function ThemeSwitcher({
	state = false,
	onChange = () => {},
	id = "themeSwitcherInput",
	leftIcon = <WbSunnyIcon />,
	rightIcon = <DarkModeIcon />,
} : IThemeSwitcher) {
	const { state: curState, updateState } = myUseState<IState>({
		state,
	});

	function toggleState() {
		const curValue = curState.state;
		const newValue = !curValue;

		updateState({
			state: newValue,
		});
		onChange({
			state: newValue,
		});
	}

	return <label className="themeSwitcher" htmlFor={id}>
		<div className={`toggle ${curState.state ? "enabled" : "disabled"}`}>
			<div className="icons">
				{leftIcon}
				{rightIcon}
			</div>
			<input id={id} type="checkbox" checked={curState.state} onChange={toggleState} />
		</div>
	</label>;
}
